import { styled } from "styled-components";

import { ExpandableContent } from "common/components";
import { AutocompleteOptionTag } from "common/components/form/Autocomplete/AutocompleteOptionTag";

export type SelectedTopicOption = {
  id: string;
  name: string;
};

type SelectedTopicsProps = {
  selectedTopics?: SelectedTopicOption[];
  isDisabled?: boolean;
  onSelectedTopicPress: (item: { id: string; name: string }) => void;
};

export const SelectedTopics = ({ selectedTopics, isDisabled, onSelectedTopicPress }: SelectedTopicsProps) => {
  if (!selectedTopics) return null;

  return (
    <ExpandableContent isActive={selectedTopics.length !== 0}>
      <StyledTagContainer hasTags={selectedTopics.length !== 0}>
        {selectedTopics.map((item) => (
          <AutocompleteOptionTag
            key={`selected-tag-${item.id}`}
            label={item.name}
            disabled={isDisabled}
            onClick={() => onSelectedTopicPress(item)}
            isSelected
          />
        ))}
      </StyledTagContainer>
    </ExpandableContent>
  );
};

const StyledTagContainer = styled.div<{ hasTags: boolean }>`
  transition: margin-bottom 0.3s;
  margin-bottom: ${({ hasTags }) => (hasTags ? "calc(1rem - 10px)" : "1rem")};
`;
